import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

export default function WeeklyRanking() {
  const ranked = [...allComics].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">本周评分最高的作品</p>
        </div>
      </div>
      <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
        {ranked.map((comic, idx) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className={`flex items-center gap-4 px-4 md:px-6 py-3 hover:bg-primary-50/20 transition-colors cursor-pointer ${
              idx < ranked.length - 1 ? 'border-b border-background-200/30' : ''
            }`}
          >
            <div className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
              idx === 0 ? 'bg-accent-500 text-white' :
              idx === 1 ? 'bg-secondary-400 text-white' :
              idx === 2 ? 'bg-secondary-300 text-white' :
              'bg-secondary-100 text-secondary-700'
            }`}>
              {idx + 1}
            </div>
            <div className="w-10 h-14 rounded overflow-hidden flex-shrink-0">
              <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground-800 line-clamp-1">{comic.title}</h4>
              <p className="text-xs text-foreground-400 mt-0.5">{comic.author} · {comic.category}</p>
            </div>
            <div className="flex items-center gap-1 text-accent-500 text-sm font-semibold flex-shrink-0">
              <i className="ri-star-fill text-xs"></i>
              {comic.rating}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}